// import

import type {ComponentProps} from 'react';

import type {UrlNode} from 'libs/model';
import {Link} from 'modules/Link';
import {Type} from 'modules/Type';

// types

type Props = ComponentProps<typeof Type> & {
  link?: boolean;
  node: UrlNode;
};

// component

export function Header(props: Props) {
  const {node: {meta}, link, ...rest} = props;

  return (
    <Type {...rest} as="header">
      <h1 className="title">
        {link ? (
          <Link className="unstyled" href={meta.link}>{meta.title}</Link>
        ) : meta.title}
      </h1>
    </Type>
  );
}
